import isObject from './is-object.js';
function recursiveFreeze(obj) {
    const frozenObject = {};
    for (const [key, value] of Object.entries(obj)) {
        let frozenValue = value;
        if (Array.isArray(value)) {
            frozenValue = Object.freeze(value);
        }
        else if (isObject(value)) {
            frozenValue = recursiveFreeze(value);
        }
        frozenObject[key] = frozenValue;
    }
    return Object.freeze(frozenObject);
}
export default recursiveFreeze;
//# sourceMappingURL=recursive-freeze.js.map